import {sendGAEvent, sendGAPageView, setGAUserId} from '../../common/analytics';
import {TRACK_GA_EVENT, TRACK_GA_PAGEVIEW, GOTO_STEP, INIT_MEMBER_DETAILS, SET_MEMBER_DATA, ERROR_FETCHING, MESSAGE_DATA, SET_ADDRESS_VALIDATION_ERROR} from '../../actions/actionTypes';
import {JoinSteps} from '../../common/constants';
import * as GA from '../../actions/common/gaActions';

export function gaReducer(state, action) {
    state = state || {};

    switch (action.type) {
        case TRACK_GA_EVENT:
            sendGAEvent(action.category, action.action, action.label, action.value);
            break;
        case TRACK_GA_PAGEVIEW:
            sendGAPageView(action.pageUrl);
            break;
        case GOTO_STEP:
            const step = action.step === JoinSteps.THANK_YOU ? "thankyou" : action.step;
            sendGAPageView(window.location.pathname + "/" + step);
            break;
        case(INIT_MEMBER_DETAILS):
        case(SET_MEMBER_DATA):
            const memberDetails = (action.type === INIT_MEMBER_DETAILS && window.Farmigo) ? window.Farmigo.memberDetails : action.memberDetails;
            if (memberDetails && memberDetails.key)
                setGAUserId(memberDetails.key);
            break;
        case (ERROR_FETCHING):
            sendGAEvent(GA.GA_CATEGORIES.MESSAGES, GA.GA_ACTIONS.ERROR_FETCHING, action.error.message);
            break;
        case (MESSAGE_DATA):
            if (action.messageData.messageTitle)
                sendGAEvent(GA.GA_CATEGORIES.MESSAGES, GA.GA_ACTIONS.MESSAGE, action.messageData.messageTitle);
            break;
        case (SET_ADDRESS_VALIDATION_ERROR):
            sendGAEvent(GA.GA_CATEGORIES.MESSAGES, GA.GA_ACTIONS.ADDRESS_VALIDATION_ERROR, action.error);
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/common/gaReducer.js